export function escapeHtml (str) {
  if (str == null || str === '') return ''
  const s = String(str)
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}



// WEBPACK FOOTER //
// ./src/utils/html.js